import { useState, useEffect, useMemo } from "react";
import { getProgress } from "../../../api/process";

const ActivitySearch = ({ projectId, value, onChange }) => {
  const [activities, setActivities] = useState([]);
  const [query, setQuery] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  // 데이터 로드
  useEffect(() => {
    if (!projectId) return;
    setLoading(true);
    getProgress().then((data) => {
      setActivities(Array.isArray(data.activities) ? data.activities : []);
      setLoading(false);
    });
  }, [projectId]);

  // 검색 필터링
  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return activities;
    return activities.filter(
      (a) =>
        a.name.toLowerCase().includes(q) ||
        (a.activity_code && a.activity_code.toLowerCase().includes(q))
    );
  }, [activities, query]);

  // 선택 핸들러
  const handleSelect = (activity) => {
    onChange(activity);
    setQuery("");
    setIsModalOpen(false);
  };

  return (
    <div>
      {/* 선택된 Activity 표시 */}
      <div className="flex items-center gap-2">
        <input
          type="text"
          value={value?.name || ""}
          readOnly
          className="border p-2 rounded-md flex-1 bg-gray-100 cursor-pointer"
          onClick={() => setIsModalOpen(true)}
          placeholder="작업(Activity) 선택"
        />
        <button
          onClick={() => setIsModalOpen(true)}
          className="px-3 py-2 bg-blue-500 text-white rounded-md"
          type="button"
        >
          검색
        </button>
      </div>

      {/* 모달 */}
      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          <div className="bg-white rounded-lg shadow-lg w-[500px] flex flex-col">
            {/* 헤더 */}
            <div className="flex justify-between items-center p-4 border-b">
              <h2 className="font-bold text-lg">작업(Activity) 검색</h2>
              <button
                onClick={() => setIsModalOpen(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                ✕
              </button>
            </div>

            {/* 검색창 */}
            <div className="p-4 border-b">
              <input
                type="text"
                placeholder="검색어 입력"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && filtered[0]) {
                    handleSelect(filtered[0]);
                  }
                }}
                className="border p-2 w-full rounded-md"
              />
            </div>

            {/* 검색 결과 (고정 높이) */}
            <div className="overflow-y-auto h-[400px]">
              {loading ? (
                <div className="p-4 text-gray-500 text-sm text-center">
                  불러오는 중...
                </div>
              ) : filtered.length === 0 ? (
                <div className="p-4 text-gray-500 text-sm text-center">
                  검색 결과 없음
                </div>
              ) : (
                <ul>
                  {filtered.map((a) => (
                    <li
                      key={a.id}
                      className="p-3 hover:bg-blue-100 cursor-pointer border-b"
                      onClick={() => handleSelect(a)}
                    >
                      <div className="font-medium">
                        [{a.activity_code}] {a.name}
                      </div>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ActivitySearch;
